var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-article"},[_c('h2',[_vm._v("Politique de confidentialité - RGPD")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('legal',{scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{domProps:{"innerHTML":_vm._s(props.content)}})]}}])}),_vm._v(" "),_c('br'),_c('br')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec7ea84e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RGPD.vue
// module id = +GdD
// module chunks = 0